import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';

const BuyNormalUser = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { profile } = useSelector(state => state.user);

    const handleBarcodeGenerateClick = () => {
        navigate('../barcode_generate');
    };

    const handleTransferWalletClick = () => {
        navigate('../transfer/search');
    };

    const handleBackBtn = () => {
        navigate(-1);
    };

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="buy-normal-user-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10}><h4 className="text-center">خرید با کیف پول سیتگ</h4></Col>
                <Col xs={1}></Col>
            </Row>
            

            <div className="primary-border p-3" style={{marginTop: "5rem"}}>
                <Row className="font-weight-200">
                    <Col xs={6} className="text-center">
                        موجودی کیف پول:
                    </Col>
                    <Col xs={6} className="text-center">
                        {profile.user_credit.toLocaleString()} ریال
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12}>
                        <Link to="../charge-wallet">
                            <Button className="primary-border bg-secondary primary-txt-color font-weight-300 radius-12 w-100 py-2">
                                شارژ کیف پول
                            </Button>
                        </Link>
                    </Col>
                    <Col xs={12}>
                        <Button className="primary-btn radius-12 w-100 mt-3 py-2" onClick={handleTransferWalletClick}>
                            انتقال وجه از کیف پول به فروشگاه
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <Button className="primary-btn radius-12 w-100 mt-3 py-2" onClick={handleBarcodeGenerateClick}>
                            ایجاد بارکد جهت پرداخت
                        </Button>
                    </Col>
                </Row>
            </div>


            {/*<h6 style={{marginTop: "4rem"}}>کاربر عزیز</h6>*/}
            <div className="font-weight-300 mt-4 text-justify">
                برای پرداخت خریدهای حضوری و تلفنی از فروشگاه های طرف قرارداد میتوانید از یکی از این دو روش استفاده کنید:
                <ul className="mt-3">
                    <li>
                        <strong>انتقال وجه: </strong> با این روش میتوانید مبلغ خرید خود را از کیف پول خود به فروشگاه انتقال دهید.
                    </li>
                    <li className="mt-2">
                        <strong>ایجاد بارکد: </strong> با ایجاد بارکد و نمایش آن به صندوقدار، مبلغ خرید شما توسط صندوقدار از کیف پول شما کسر  میگردد
                    </li>
                </ul>
            </div>

            
        </div>

    );
}

export default BuyNormalUser;